import './css/viciCommon.css';
import './css/vscb.css';
import viciCommon from './viciCommon';
import config from './config';
import { ethers } from 'ethers'
import Cookies from 'js-cookie'
import erc20Abi from './erc20_abi.js';

let cbHeaders = {
	'Content-Type' : 'application/json'
};

let hasNatives ={
	usd: true,
	usdc: true,
	eur: false,
	eurc: false,
}

let user = {};
const iv='a8ce0abd659ff3d6508515facccae7d6';
const k='77f9afdadc9959865fed7ff8b4343473'

let clickType, oneClick = false;
let swapToCoins = new Array(), swapFromCoins = new Array(), coinMap = new Map(), accountMap = new Map();
let fromCoins = new Array(), toCoins = new Array(), quoteTimer;
let tosResolve;
let provider, signer, chainId = -1, logBundleId = -1;

//Alert and confirm don't work on coinbase mobile
alert = await viciCommon.viciAlert;
confirm = await viciCommon.viciConfirm;

$(async function() {
	//-----Init-----
	viciCommon.addMessage("Loading...", "message", 30000);

	try{
		let envConfig = await import('./env.conf');
		config.remoteLogging = envConfig.default.remoteLogging;
	}catch(e){
		console.log("Could not load env override config");
	}

	$('#wrapper').show();
	$('input.swap_amounts').val("");
	$('#to_search').val("");
	$('#select_all_from').prop('checked', false);
	$('#select_all_to').prop('checked', false);

	//Fix issue with click not working on mobile
	if(window.matchMedia("(pointer: coarse)").matches) {
		clickType='touchstart';
	}else{
		clickType='click'
	}

	const urlParams = new URLSearchParams(window.location.search);
	let auth = await isAuth();
	let totalCoins;
	if(auth){
		totalCoins = await initToCoins();
		await initFromCoins();

		$('#get_quotes').show();
		$('#one_swap').show();
		$('#wrapper_inner').show();
		user = await getUser();

		//Link account
		if(user && user.newUser===true){
			let vici_provider = Cookies.get('vici_provider');
			if(vici_provider){
				connectWallet();
			}else{
				showNewUser(1);
			}
		}
		if(user){
			console.log(user.name+" logged in");
			console.log("Running build #"+__VERSION__);
			console.log(totalCoins+" swap to coins");
		}
	}

	if(config.remoteLogging){
		if(!viciCommon.logSocket){
			//Lumberjack Remote logging
			console.log("Switching to lumberjack");
			if(user.email){
				console = await viciCommon.initLogSocket(config.lumberjackLocation, 'vscb', user.email);
			}else{
				console = await viciCommon.initLogSocket(config.lumberjackLocation, 'vscb');
			}

			document.addEventListener("visibilitychange", async () => {
			  if (!document.hidden) {
				if(!config.lumberjackLocation){
					await alert('Session timed out. Reloading.')
					window.location.reload();
				}
				if(!viciCommon.initLogSocket){
					console = await viciCommon.initLogSocket(config.lumberjackLocation, 'viciswap');
				}
			  }
			});
		}
	}

	let url = new URL(window.location);
	let searchParams = new URLSearchParams(url.search);
	let bundle_id=searchParams.get('b');
	if(bundle_id && bundle_id.length){
		try{
			bundle_id = await dec(iv, k, bundle_id);
			console.log(bundle_id)
		}catch(e){
			console.error(e);
		}
		if(Number.isInteger(parseInt(bundle_id))){
			if(parseInt(searchParams.get('c')) > 0 && parseInt(searchParams.get('c')) != chainId && parseInt(searchParams.get('c')) in config.chains){
				chainId = parseInt(searchParams.get('c'));
				await switchChain();
			}

			if (history.pushState) {
				var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
				window.history.pushState({path:newurl},'',newurl);
			}
			await loadBundle(bundle_id);
		}
	}
	if(totalCoins > 0){
		viciCommon.hideMessage();
	}


	//-----Events-----
	$(document).on(clickType,"#connect_wallet", async function(event) {
		await connectWallet();
	});

	$(document).on(clickType,"#chainPicker li", async function(event) {
		$("#chainPicker li").removeClass('selected');
		$(this).addClass('selected');
	});

	$(document).on(clickType,"#pick_chain", async function(event) {
		$("#chainPicker li").each(function(){
			if($(this).hasClass('selected')){
				chainId=$(this).data('chainid');
			}
		});

		if(chainId > 0){
			showNewUser(3);
		}else{
			await alert('You must pick a chain');
		}
	});

	$(document).on(clickType,"#approve_spending_limit", async function(event) {
		await getPermit();
	});

	$(document).on(clickType,"#bundles", async function(event) {
		showBundles();
	});

	$(document).on(clickType,"#show_add_bundle", async function(event) {
		viciCommon.hideMessage();
		let modalContent='<div id="bundle_wrapper">';
		modalContent+='<h2>Add Token Bundle</h2>\
		<form id="add_bundle_form">\
		Name <input type="text" id="bundle_name" name="bundle_name" placeholder="Bundle name"><br>\
		Coins to add <input type="text" id="bundle_filter" name="bundle_filter" placeholder="Search">';
		modalContent+='<ul id="bundle_coin_list">\n';
		swapToCoins.sort((a, b) => a.symbol.localeCompare(b.symbol));//Make them alphabetical
		
		
		for(let toCoin of swapToCoins){
			modalContent+='<li class="bundle_coin_item" data-symbol="'+toCoin.symbol+'">\
			<div class="bundle_list_inner"><input type="checkbox" class="bundle_coin" name="bundle_coin" value="'+toCoin.symbol+'"> \
			<div class="crop"><img src="img/coins/'+toCoin.symbol+'.png" alt="'+toCoin.symbol+'"></div> \
			'+toCoin.displaySymbol+'</div>\
			</li>'
		}

		modalContent+='</ul><button type="submit" id="save_bundle">Save</button></form></div>';
		await viciCommon.showModal(modalContent, false);

		let addBundleForm = document.querySelector('#add_bundle_form');
		addBundleForm.addEventListener("submit", async (event) => {
			event.preventDefault();
			let selectedCoins = [];
			$(".bundle_coin:checked" ).each(async function(){
				selectedCoins.push($(this).val());
			});
			if(selectedCoins.length==0){
				viciCommon.addMessage("You must select some coins", "error", 30000);
				return;
			}

			if($('#bundle_name').val()==''){
				viciCommon.addMessage("You must give the bundle a name", "error", 30000);
				return;
			}

			let bundle = {'name': $('#bundle_name').val(), 'coins': selectedCoins}
			console.log(bundle)
			let res = await doAjax('api/bundle', bundle, 'POST', cbHeaders);
			viciCommon.hideMessage();
			showBundles();
		});
	});

	$(document).on(clickType,".bundle_edit", async function(event) {
		let bundle_id=$(this).data('bundle_id');
		let bundle = await doAjax('api/bundle?bundle_id='+bundle_id, {'Content-Type' : 'application/json'}, 'GET');
		if(bundle.status){
			bundle = bundle.bundle
			viciCommon.hideMessage();
			let modalContent='<div id="bundle_wrapper">';
			modalContent+='<h2>Edit Token Bundle</h2>\
			<form id="add_bundle_form">\
			<input type="text" id="bundle_name" name="bundle_name" value="'+bundle.name+'"><br>\
			Coins to add  <input type="text" id="bundle_filter" name="bundle_filter" placeholder="Search">';
			modalContent+='<ul id="bundle_coin_list">\n';

			swapToCoins.sort((a, b) => a.symbol.localeCompare(b.symbol));
			for(let toCoin of swapToCoins){
				modalContent+='<li data-symbol="'+toCoin.symbol+'" class="bundle_coin_item">\
				<div class="bundle_list_inner">';
				if(bundle.coins.findIndex(i => i === toCoin.symbol) > -1){
					modalContent+='<input type="checkbox" class="bundle_coin" name="bundle_coin" value="'+toCoin.symbol+'" checked="checked">';
				}else{
					modalContent+='<input type="checkbox" class="bundle_coin" name="bundle_coin" value="'+toCoin.symbol+'">';
				}
				modalContent+='<div class="crop"><img src="img/coins/'+toCoin.symbol+'.png" alt="'+toCoin.symbol+'"></div> \
				'+toCoin.symbol+'</div>\
				</li>'
			}

			modalContent+='</ul><button type="submit" id="save_bundle">Save</button></form></div>';
			await viciCommon.showModal(modalContent, false);

			let addBundleForm = document.querySelector('#add_bundle_form');
			addBundleForm.addEventListener("submit", async (event) => {
		 		event.preventDefault();
				let selectedCoins = [];
				$(".bundle_coin:checked" ).each(async function(){
					selectedCoins.push($(this).val());
				});
				if(selectedCoins.length==0){
					viciCommon.addMessage("You must select some coins", "error", 30000);
					return;
				}

				if($('#bundle_name').val()==''){
					viciCommon.addMessage("You must give the bundle a name", "error", 30000);
					return;
				}

				let bundle = {'name': $('#bundle_name').val(), 'coins': selectedCoins, 'bundle_id':bundle_id}
				let res = await doAjax('api/bundle', bundle, 'PATCH', cbHeaders);
				if(res.status){
					showBundles();
					viciCommon.hideMessage();
				}else{
					viciCommon.addMessage("Error saving bundle", "error", 30000);
				}
			});
		}else{
			viciCommon.addMessage("Error loading bundle", "error", 30000);
		}
	});

	$(document).on(clickType,".bundle_run", async function(event) {
		let bundle_id=$(this).data('bundle_id');
		if(Number.isInteger(parseInt(bundle_id))){
			loadBundle(bundle_id);
		}
	});

	$(document).on('input',"#bundle_filter", async function(event) {
		swapToCoins.sort((a, b) => a.symbol.localeCompare(b.symbol));//Make them alphabetical
		const filtered = swapToCoins.filter(coinSymbolContains($(this).val()));
		$('#bundle_coin_list .bundle_coin_item').hide();
		for(let coin of filtered){
			$('#bundle_coin_list .bundle_coin_item[data-symbol="'+coin.symbol+'"]').show();
		}
	});


	$(document).on(clickType,".bundle_delete", async function(event) {
		if(await confirm("Are you sure?")){
			let bundle_id=$(this).data('bundle_id');
			let data = {'bundle_id': bundle_id};
			let res = await doAjax('api/bundle', data, 'DELETE', cbHeaders);
			showBundles();
		}
	});

	$('#to_search').on('input',function(e){
		const filtered = swapToCoins.filter(coinSymbolContains($(this).val()));
		$('#to_coin_select .coin_selector_item').hide();
		for(let coin of filtered){
			$('#to_coin_select .coin_selector_item[data-symbol="'+coin.symbol+'"]').show();
		}
	});

	function coinSymbolContains(search) {
		return function(element) {
			let lowerSymbol = element.symbol.toLowerCase();
			return lowerSymbol.indexOf(search.toLowerCase()) > -1;
		}
	}

	$('#all_up_to').on(clickType,function(e){
		$('.swap_to_checkboxes:visible[data-updn="up"]').prop('checked', true);
		$('.swap_to_checkboxes:visible[data-updn="dn"]').prop('checked', false);
	});

	$('#all_up_from').on(clickType,function(e){
		$('.swap_from_checkboxes:visible[data-updn="up"]').prop('checked', true);
		$('.swap_from_checkboxes:visible[data-updn="dn"]').prop('checked', false);
	});

	$('#all_dn_to').on(clickType,function(e){
		$('.swap_to_checkboxes:visible[data-updn="up"]').prop('checked', false);
		$('.swap_to_checkboxes:visible[data-updn="dn"]').prop('checked', true);
	});

	$('#all_dn_from').on(clickType,function(e){
		$('.swap_from_checkboxes:visible[data-updn="up"]').prop('checked', false);
		$('.swap_from_checkboxes:visible[data-updn="dn"]').prop('checked', true);
	});


	$("#select_all_from").change(async function() {
		let allCheckedFrom= $(this).prop('checked');

		if(allCheckedFrom===true){
			$('.swap_from_checkboxes').prop('checked', true);
		}else{
			$('.swap_from_checkboxes').prop('checked', false);
		}
	});

	$("#select_all_to").change(async function() {
		let allCheckedTo= $(this).prop('checked');
		if(allCheckedTo===true){
			$('.swap_to_checkboxes:visible').prop('checked', true);
		}else{
			$('.swap_to_checkboxes:visible').prop('checked', false);
		}
	});

	$(document).on(clickType,"#max_from", async function() {
		maxFrom();
	});

	$(document).on(clickType,"#get_quotes", async function() {
		getQuotes();
	});

	$(document).on(clickType,"#do_swap", async function() {
		await doSwaps();
	});

	$(document).on(clickType,"#logout", async function() {
		if(await confirm('This will remove ViciSwap\'s access to CoinBase, it will not log you out of Coinbase.') == true){
			let x = await doAjax('api/logout', {}, 'GET', cbHeaders);
			await isAuth();
		}
	});

	$(document).on(clickType,"#reset", async function() {
		if(await confirm('This will remove ViciSwap\'s access to CoinBase, and reset everything. You will need to start over. Are you sure?') == true){
			let x = await doAjax('api/reset', {}, 'GET', cbHeaders);
			let vici_provider = Cookies.remove('vici_provider');
			await isAuth();
		}
	});

	$("#one_swap").click(async function() {
		getQuotes();
		oneClick = true;
	});

	$(document).on('change','.swap_to_checkboxes', async function() {
		logBundleId = -1;
	});
});

async function getPermit(){
	let permitInfo, permitRes;
	const userAddress = await signer.getAddress();
	try{
		permitInfo = await doAjax(`api/permit?chain_id=${chainId}&user_address=${userAddress}`, {}, 'GET', {});
	}catch(e){
		console.error(e);
	}

	let pChainId = await vicinft.provider.request({ method: 'eth_chainId' });
	pChainId=parseInt(pChainId, 16);
	if(pChainId != chainId){
		console.log("Switching chains to "+chainId);
		window.vicinft.config.chainId=chainId;
		window.vicinft.switchChain();
	}

	if(permitInfo.status===true){
		let sigRes = await signPermit(permitInfo.spenderAddress, permitInfo.deadline);
		let data = {
			chain_id: chainId,
			nonce: sigRes.nonce,
			sig: sigRes.sig,
			userAddress: userAddress,
			deadline: permitInfo.deadline,
		}
		try{
			let permitRes = await doAjax('api/permit?chain_id='+chainId, data, 'POST', cbHeaders);
			if(permitRes && permitRes.status===true){
				console.log(`User ${permitRes.user.name} -  ${permitRes.user.email} registered`);
				viciCommon.hideModal();
			}
		}catch(e){
			console.error(e);
		}
	}
}

async function signPermit(spenderAddress, deadline){
	let data, sig, nonce;
	const userAddress = await signer.getAddress();

	try{
		if(!config.chains[chainId].provider){
			config.chains[chainId].provider = new ethers.JsonRpcProvider(config.chains[chainId].rpc);
		}
		if(!config.chains[chainId].vcntContract){
			config.chains[chainId].vcntContract = new ethers.Contract(config.chains[chainId].vcntAddress, erc20Abi, config.chains[chainId].provider);
		}
		nonce = await config.chains[chainId].vcntContract.nonces(userAddress);
	}catch(e){
		console.error(e);
	}

	let messageData = {
		owner: userAddress,
		spender: spenderAddress,
		value: '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff',
		nonce: parseInt(nonce),
		deadline: deadline
	};

	const domainData = {
		name: 'ViciCoin',
		version: '1',
		chainId: parseInt(chainId),
		verifyingContract: config.chains[chainId].vcntAddress,
	};

	const domainTypes = [
		{ name: "name", type: "string" },
		{ name: "version", type: "string" },
		{ name: "chainId", type: "uint256" },
		{ name: "verifyingContract", type: "address" },
	];

	const permitTypes = [
		{ name: "owner", type: "address" },
		{ name: "spender", type: "address" },
		{ name: "value", type: "uint256" },
		{ name: "nonce", type: "uint256" },
		{ name: "deadline", type: "uint256" },
	];

	try{
		data = JSON.stringify({
			types: {
				EIP712Domain: domainTypes,
				Permit : permitTypes
			},
			domain: domainData,
			primaryType: "Permit",
			message: messageData
		});
	}catch(e){
		console.error(e)
	}

	try{
		sig = await provider.request({
			method: "eth_signTypedData_v3",
			params: [userAddress, data]
		});
	}catch(e){
		console.error(e)
	}

	return {
		nonce: parseInt(nonce),
		sig: sig
	};
}

async function connectWallet(){
	if(window.vicinft.initialized===false){//We can't guarantee that init has finished so we wait for promise
		await window.vicinft.waitForInit();
	}

	vicinft.disableMagic=true;
	let providerRes = await window.vicinft.getProvider();

	if(providerRes){
		provider = providerRes.provider;
		let account;
		try{
			account = await provider.request({method: 'eth_requestAccounts'});
		}catch(e){
			await alert('Could not load your wallet, is it locked? Please check it and try again.');
			showNewUser(1);
		}

		let eProvider = new ethers.BrowserProvider(provider);//v6
		signer = await eProvider.getSigner();//v6
		let userAddress = await signer.getAddress();

		if(ethers.isAddress(userAddress) && chainId <= 0){
			showNewUser(2);
		}else if(ethers.isAddress(userAddress) && chainId > 0){
			const userAddress = await signer.getAddress();
			let permitInfo;
			try{
				permitInfo = await doAjax(`api/permit?chain_id=${chainId}&user_address=${userAddress}`, {}, 'GET', {});
			}catch(e){
				console.error(e);
			}
			if(!permitInfo || !permitInfo.allowance){
				showNewUser(3);
			}
		}else{
			showNewUser(1);
		}
	}
}

async function showNewUser(step){
	viciCommon.hideMessage();
	let modalContent='<div id="new_user_modal">';
	modalContent+='<h2 class="center">Welcome to ViciSwap</h2>\
	Before you can continue, you must have some VCNT to pay for swap fees and approve our contract to deduct the fees on your behalf. \
	To do this, you must use a web3-enabled browser. There are three steps you will need to follow: \
	<button id="connect_wallet">Connect your wallet</button><br>\
	<button id="pick_chain" disabled="disabled">Select chain</button> \
	<button id="approve_spending_limit" disabled="disabled">Approve spending cap</button>';
	modalContent+='</div>';
	await viciCommon.showModal(modalContent, true);
	if(step==2){
		$('#pick_chain').before('<img src="img/loading.gif" id="chains_loading" alt="loading">');
		let userAddress = await signer.getAddress();
		$("#connect_wallet").css('background', 'grey');
		$("#connect_wallet").css('cursor', 'not-allowed');
		$('#connect_wallet').attr('disabled','disabled');
		$('#connect_wallet').after('<div class="center" id="userAddress">'+userAddress+'</div>');
		$('#connect_wallet').after('<img src="img/check.png" alt="check" id="check">');

		$("#pick_chain").css('background', '#015073');
		$("#pick_chain").css('cursor', 'pointer');
		$('#pick_chain').removeAttr('disabled');

		$('#pick_chain').before($("<ul>").attr('id', 'chainPicker'));
		let largestBalance = 0;
		let largestBalanceChain;
		let chainCount = 0;
		for (const [chainId, chain] of Object.entries(config.chains)) {
			config.chains[chainId].provider = new ethers.JsonRpcProvider(chain.rpc);
			config.chains[chainId].vcntContract = new ethers.Contract(config.chains[chainId].vcntAddress, erc20Abi, config.chains[chainId].provider);
			let vcntBalance = await config.chains[chainId].vcntContract.balanceOf(userAddress);
			vcntBalance = ethers.formatUnits(vcntBalance, 18);
			if(parseFloat(vcntBalance) > 0){
				chainCount++;
				if(parseFloat(vcntBalance) > largestBalance){
					largestBalance = parseFloat(vcntBalance);
					largestBalanceChain=chainId;
				}
				let dec = vcntBalance.indexOf('.');
				if(vcntBalance.length - dec > 3){
					vcntBalance=vcntBalance.substring(0, dec+3);
				}
				$('#chainPicker').append($('<li>').attr('data-chainid', chainId).text(` VCNT balance ${vcntBalance}`).prepend($('<img>').attr('src', chain.image)));
			}
		}
		$('#chainPicker li[data-chainid="'+largestBalanceChain+'"]').addClass('selected');
		$('#chainPicker li').css('visibility', 'visible');
		$('#chains_loading').remove();

		if(chainCount <= 0){
			$('#chainPicker').remove();
			$('#new_user_modal').html(`<h2 class="center">No VCNT found!</h2>\
			In order to use this app you must have the coin VCNT to pay for fees. The easiest way to buy VCNT is in the Coinbase wallet. \
			Open your Coinbase wallet, press the "buy" button, and follow the prompts.\
			<br><br>\
			If you don't have Coinbase wallet you can <a href="https://www.coinbase.com/wallet" target="_blank">get it for free here.</a>

			`)
		}

	}else if(step==3){
		$("#connect_wallet").css('background', 'grey');
		$("#connect_wallet").css('cursor', 'not-allowed');
		$('#connect_wallet').attr('disabled','disabled');
		$('#connect_wallet').after('<img src="img/check.png" alt="check" id="check">')

		$("#pick_chain").css('background', 'grey');
		$("#pick_chain").css('cursor', 'not-allowed');
		$('#pick_chain').attr('disabled','disabled');
		$('#pick_chain').after('<img src="img/check.png" alt="check" id="check">')

		$("#approve_spending_limit").css('background', '#015073');
		$("#approve_spending_limit").css('cursor', 'pointer');
		$('#approve_spending_limit').removeAttr('disabled');
	}
}

async function loadBundle(bundle_id){
	let bundleRes = await doAjax('api/bundle?bundle_id='+bundle_id, {}, 'GET', );
	if(bundleRes.status){
		viciCommon.hideModal();
		let bundle = bundleRes.bundle;

		await $('.swap_to_checkboxes').prop('checked', false).trigger('change');
		if(bundle.coins && bundle.coins.length){
			for(let coin of bundle.coins){
				await $('.swap_to_checkboxes[data-symbol="'+coin.toLowerCase()+'"]').prop('checked', true).trigger('change');
				let toCoin = $('#to_coin_select .coin_selector_item[data-symbol="'+coin.toLowerCase()+'"]');
				toCoin.remove();
				$('#to_coin_select').prepend(toCoin);
			}
			viciCommon.addMessage("Coins loaded. Click to swap.", "message", 30000);
			logBundleId = bundle_id;
		}
	}
}

async function showBundles(){
	let bundles = await doAjax('api/bundles');
	let modalContent='<div id="bundle_wrapper">';
	modalContent+='<h2>Token Bundles</h2>\
	A selection of coins you may swap to';
	modalContent+='<ul id="bundle_list">\n';
	modalContent+='</ul><button id="show_add_bundle">Add New Bundle</button></div>';
	await viciCommon.showModal(modalContent, false);
	if(bundles.status==true){
		for(let bundle of bundles.bundles){
			let bundleLine = '<li class="bundle" data-bundle_id="'+bundle.bundle_id+'">';

			bundleLine = bundleLine + '<span class="bundle_name"></span>';
			bundleLine = bundleLine + '<span class="bundle_action_icons"> ';
			if(bundle.owned){
				bundleLine = bundleLine + '<img src="img/trash.png" alt="Delete" title="Delete" class="bundle_delete" data-bundle_id="'+bundle.bundle_id+'"><img src="img/pencil.png" alt="Edit" title="Edit" class="bundle_edit" data-bundle_id="'+bundle.bundle_id+'">';
			}
			bundleLine = bundleLine + '<img src="img/share.png" alt="Share" title="Share" class="bundle_share" data-bundle_id="'+bundle.bundle_id+'"><img src="img/play.png" alt="Play" title="Play" class="bundle_run" data-bundle_id="'+bundle.bundle_id+'">\
			</span>';

			bundleLine = bundleLine + '</li>';


			$('#bundle_list').append(bundleLine);

			if(!bundle.owned){
				if(bundle.name.indexOf('CB') === 0){
					$('.bundle_name:last').text(bundle.name.substring(3, bundle.name.length));
					$('.bundle_name:last').prepend( '<img src="img/coinbase.png" alt="Coinbase" title="Coinbase bundle" class="bundle_vici"></img>');
				}else if(bundle.name.indexOf('Robinhood') === 0){
					$('.bundle_name:last').text(bundle.name);
					$('.bundle_name:last').prepend( '<img src="img/robinhood.png" alt="Robinhood" title="Robinhood bundle" class="bundle_vici"></img>');
				}else if(bundle.name.indexOf('Forbes') === 0){
					$('.bundle_name:last').text(bundle.name);
					$('.bundle_name:last').prepend( '<img src="img/forbes.png" alt="Forbes" title="Forbes bundle" class="bundle_vici"></img>');
				}else if(bundle.name.indexOf('Binance') === 0){
					$('.bundle_name:last').text(bundle.name);
					$('.bundle_name:last').prepend( '<img src="img/binance.png" alt="Binance" title="Binance bundle" class="bundle_vici"></img>');
				}else{
					$('.bundle_name:last').text(bundle.name);
					$('.bundle_name:last').prepend( '<img src="img/thanos_green.png" alt="viciBundle" title="Vici Chosen Bundle" class="bundle_vici"></img>');
				}
			}else{
				$('.bundle_name:last').text(bundle.name);
			}

		}

		const bundle_share = document.querySelectorAll('.bundle_share');
		bundle_share.forEach(el => el.addEventListener("click", async (event) => {
			let bundle_id=event.target.getAttribute("data-bundle_id");
			let bid = await enc(iv, k, bundle_id);
			copyToClipboard(window.location.protocol + "//" + window.location.host + window.location.pathname+'?b='+bid);
		}));
	}else{
		viciCommon.addMessage("Error loading bundles", "error", 30000);
		console.log("Error loading bundles "+bundles.error);
	}
}

async function doSwaps(){
	let now = (new Date()).getTime() / 1000;
	$('#do_swap').hide();
	if(quoteTimer){
		clearTimeout(quoteTimer)
	}

	viciCommon.addMessage('Running...', "message", 30000);

	let data = {
		fromCoins: fromCoins,
		toCoins: toCoins,
		bundleId: logBundleId,
	}
	let swapRes
	try{
		swapRes = await doAjax('api/multiswap', data, 'POST', cbHeaders)
	}catch(e){
		console.error(e);
	}
	logBundleId = -1;
	await initToCoins();
	await initFromCoins();
	$('#get_quotes').show();
	$('#one_swap').show();


	if(swapRes.status===true){
		let swapsDone = swapRes.swapsDone;
		let sla = swapRes.sla;
		let then = (new Date()).getTime() / 1000;
		if(swapsDone > 0){
			viciCommon.addMessage(swapsDone+' swaps completed successfully in '+(then - now).toFixed(2)+' seconds', "message", 30000);
			console.log(swapsDone+' of '+sla.length+' swaps completed successfully in '+(then - now).toFixed(2)+' seconds')
			setTimeout(function(){viciCommon.hideMessage();}, 10000);
		}else{
			viciCommon.hideMessage();
		}
	}else{
		viciCommon.addMessage(swapRes.error, "error", 30000);
	}

}


// async function doSwaps(){
// 	let now = (new Date()).getTime() / 1000;
// 	$('#do_swap').hide();
// 	let fromSwaps = [], toSwaps = [];
// 	let fromResults = [], toResults = [];
// 	let fromChecks = [], toChecks = [];
// 	let fromCheckResults = [], toCheckResults = [];
// 	let swapLogs = new Map();
// 	let tc = 0;
// 	let batchCoins='', comma='';
//
// 	if(quoteTimer){
// 		clearTimeout(quoteTimer)
// 	}
//
// 	await getPrices(); //Get all prices
//
// 	for(let fromCoin of fromCoins){
// 		if(fromCoin.isConvert){
// 			if(fromCoin.symbol=='usdc'){//USDC is different than other coins, need to convert rather than trade
// 				let fc = 'USDC';
// 				let tc = 'USD'
// 				let tradeId = await getConvertQuote(fc, tc, fromCoin.amount);
// 				if(tradeId){
// 					let convertRes = await convertCoin(tradeId, fc, tc);
// 					let swap = {
// 						time: Math.floor((new Date()).getTime() / 1000),
// 						user: user.name,
// 						userId: user.id,
// 						email: user.email,
// 						from: fc,
// 						to: tc,
// 						orderId: tradeId,
// 						amount: fromCoin.amount,
// 						status : 'PENDING',
// 					}
//
// 					if(fromCoins.length < 10){
// 						for(let i=0; i < config.swapChecks; i++){
// 							viciCommon.addMessage(fc+'/'+tc+' swap submitted awaiting confirmation', "message", 30000);
// 							let status = await getConvertStatus(tradeId, fc, tc);
// 							if(status=='TRADE_STATUS_COMPLETED'){
// 								swap.status = 'FILLED';
// 								break;
// 							}
// 							await sleep(1000);
// 						}
// 					}else{
// 						swap.status = 'FILLED';//Bad idea? We don't really know...
// 					}
// 					if(tradeId){
// 						swapLogs.set(tradeId, swap);
// 					}
// 				}
// 			}
// 		}else{
// 			let mc = coinMap.get(fromCoin.symbol);
// 			fromCoin.bestAsk=mc.bestAsk;
// 			fromCoin.bestBid=mc.bestBid;
//
// 			let bbp = parseFloat(fromCoin.bestBid.price);
// 			let bbpDec = fromCoin.bestBid.price.countDecimals();
//
// 			bbp = bbp - (bbp  * config.overAskBidMultiplier);
// 			bbp = bbp.toFixed(bbpDec);
//
// 			console.log(fromCoin.displaySymbol+ " best bid price "+fromCoin.bestBid.price+" selling at "+bbp)
//
// 			fromSwaps.push(swap(fromCoin.productId, 'SELL', (fromCoin.amount).toFixed(mc.decimals), String(bbp)));
//
// 			batchCoins=batchCoins+comma+fromCoin.displaySymbol+'/USD';
// 			if(comma=='') comma=', ';
// 			tc++;
// 			if(tc >= 9){
// 				viciCommon.addMessage("Submitting "+batchCoins, "message", 30000);
// 				batchCoins='';
// 				comma='';
// 				await sleep(1000);
// 				await getPrices(); //Get all prices
// 				tc=0;
// 			}
// 		}
// 	}
//
// 	fromResults = await Promise.raceAll(fromSwaps, config.promiseAllTimeout, 'Swap promise fail');
//
// 	for(let fromResult of fromResults){
// 		if(fromResult && fromResult.product){
// 			let coins=fromResult.product.split('-');
// 			let swap = {
// 				time: Math.floor((new Date()).getTime() / 1000),
// 				user: user.name,
// 				userId: user.id,
// 				email: user.email,
// 				from: coins[0],
// 				to: coins[1],
// 				amount: fromResult.amount,
// 			}
//
// 			if(fromResult.orderId){
// 				swap.status = 'PENDING';
// 				swap.orderId = fromResult.orderId;
// 				viciCommon.addMessage(swap.from+'/'+swap.to+' swap submitted awaiting confirmation', "message", 30000);
// 				fromChecks.push(checkSwap(swap.orderId, swap.from+'/'+swap.to));
// 				tc++;
// 				if(tc >= 15){
// 					await sleep(1000);
// 					tc=0;
// 				}
// 				swapLogs.set(swap.orderId, swap);
// 			}else{
// 				swap.status = 'FAILED';
// 				swap.error = fromResult.error;
// 				swapLogs.set(swap.userId+"-"+fromResult.product+"-"+fromResult.buySell, swap);
// 				viciCommon.addMessage(swap.from+'/'+swap.to+' swap failed', "error", 30000);
// 			}
// 		}else{
// 			console.log(fromResult)
// 		}
// 	}
//
// 	fromCheckResults = await Promise.raceAll(fromChecks, config.promiseAllTimeout, 'Swap check promise fail');
//
// 	for(let fromCheckResult of fromCheckResults){
// 		if(swapLogs.has(fromCheckResult.swapId)){
// 			let sl = swapLogs.get(fromCheckResult.swapId);
// 			sl.status = fromCheckResult.swapStatus;
// 			swapLogs.set(fromCheckResult.swapId, sl);
// 			//viciCommon.addMessage(sl.from+'/'+sl.to+' swap confirmed', "message", 30000);
// 		}
// 	}
//
// 	//Step 2 ==============
// 	await getPrices(); //Get all prices
// 	let [makerFee, takerFee] = await getFees();
// 	let usdBalance = await getAccountBalance('usd');
// 	let onHand = usdBalance/toCoins.length;
// 	console.log("On hand USD per swap to coin "+onHand+" swap amount "+toCoins[0].amount);
// 	if(toCoins[0].amount > onHand - (onHand * takerFee)){
// 		console.log('There is not enough USD to complete the step 2 swaps reducing swap from amount from '+toCoins[0].amount+" to "+(onHand - (onHand * takerFee)));
// 		for(let i=0; i<toCoins.length; i++){
// 			toCoins[i].amount = onHand - (onHand * takerFee);
// 		}
// 	}
//
//
//
// 	tc=0;
// 	batchCoins=''; comma='';
// 	for(let toCoin of toCoins){
// 		if(toCoin.isConvert){
// 			if(toCoin.symbol=='usdc'){
// 			let fc = 'USD';
// 			let tc = 'USDC'
//
// 			let tradeId = await getConvertQuote(fc, tc, toCoin.amount);
// 			if(tradeId){
// 				let convertRes = await convertCoin(tradeId, fc, tc);
// 				let swap = {
// 					time: Math.floor((new Date()).getTime() / 1000),
// 					user: user.name,
// 					userId: user.id,
// 					email: user.email,
// 					from: fc,
// 					to: tc,
// 					amount: toCoin.amount,
// 					orderId: tradeId,
// 					status : 'PENDING',
// 				}
//
// 				if(toCoins.length < 10){
// 					for(let i=0; i < config.swapChecks; i++){
// 						viciCommon.addMessage(fc+'/'+tc+' swap submitted awaiting confirmation', "message", 30000);
// 						let status = await getConvertStatus(tradeId, fc, tc);
// 						if(status=='TRADE_STATUS_COMPLETED'){
// 							swap.status = 'FILLED';
// 							break;
// 						}
//
// 						await sleep(1000);
// 					}
// 				}else{
// 					swap.status = 'FILLED';//Bad idea? We don't really know...
// 				}
//
// 				if(tradeId){
// 					swapLogs.set(tradeId, swap);
// 				}
// 			}else{
// 				console.error("Could not get tradeId");
// 			}
// 		}
// 		}else{
// 			let mc = coinMap.get(toCoin.symbol);
// 			toCoin.bestAsk=mc.bestAsk;
// 			let dec = toCoin.bestAsk.price.countDecimals();
// 			let bap = parseFloat(toCoin.bestAsk.price);
// 			bap = bap + (bap * config.overAskBidMultiplier)
// 			bap = bap.toFixed(dec);
//
// 			console.log(toCoin.symbol+ " best bid price "+toCoin.bestAsk.price+" buying at "+bap)
//
// 			toCoin.bestBid=mc.bestBid;
// 			batchCoins=batchCoins+comma+'USD/'+toCoin.displaySymbol;
// 			if(comma=='') comma=', ';
// 			toSwaps.push(swap(toCoin.productId, 'BUY', (toCoin.amount/bap).toFixed(mc.decimals), String(bap)));
// 			tc++;
// 			if(tc >= 9){
// 				viciCommon.addMessage('Submitting '+batchCoins, "message", 30000);
// 				batchCoins='';
// 				comma='';
// 				await sleep(1000);
// 				await getPrices(); //Get all prices
// 				tc=0;
// 			}
// 		}
// 	}
//
// 	toResults = await Promise.raceAll(toSwaps, config.promiseAllTimeout, 'Swap promise fail');
//
// 	for(let toResult of toResults){
// 		let coins=toResult.product.split('-');
// 		let swap = {
// 			time: Math.floor((new Date()).getTime() / 1000),
// 			user: user.name,
// 			userId: user.id,
// 			email: user.email,
// 			from: coins[1],
// 			to: coins[0],
// 			amount: toResult.amount,
// 		}
//
// 		if(toResult.orderId){
// 			swap.status = 'PENDING';
// 			swap.orderId = toResult.orderId;
// 			viciCommon.addMessage(swap.from+'/'+swap.to+' swap submitted awaiting confirmation', "message", 30000);
// 			toChecks.push(checkSwap(swap.orderId, swap.from+'/'+swap.to));
// 			tc++;
// 			if(tc >= 15){
// 				await sleep(1000);
// 				tc=0;
// 			}
// 			swapLogs.set(swap.orderId, swap);
//
// 		}else{
// 			swap.status = 'FAILED';
// 			swap.error = toResult.error;
// 			swapLogs.set(swap.userId+"-"+toResult.product+"-"+toResult.buySell, swap);
// 			viciCommon.addMessage(swap.from+''/+swap.to+' swap failed', "error", 30000);
// 		}
// 	}
//
// 	toCheckResults = await Promise.raceAll(toChecks, config.promiseAllTimeout, 'Swap check promise fail');
//
// 	for(let toCheckResult of toCheckResults){
// 		if(swapLogs.has(toCheckResult.swapId)){
// 			let sl = swapLogs.get(toCheckResult.swapId);
// 			sl.status = toCheckResult.swapStatus;
// 			swapLogs.set(toCheckResult.swapId, sl);
// 		}
// 	}
// 	let sla = [];
// 	swapLogs.forEach((value, name) => sla.push(value));
//
// 	let swapsDone = 0;
// 	for(let swapLog of sla){
// 		console.log('Swap of '+swapLog.amount+' '+swapLog.from+' to '+swapLog.to+' with id '+swapLog.orderId+' completed with status "'+swapLog.status+'"');
// 		if(swapLog.status=='FILLED'){
// 			swapsDone++;
// 		}
// 	}
//
// 	await initToCoins();
// 	await initFromCoins();
//
// 	$('#get_quotes').show();
// 	$('#one_swap').show();
// 	let then = (new Date()).getTime() / 1000;
// 	if(swapsDone > 0){
// 		viciCommon.addMessage(swapsDone+' swaps completed successfully in '+(then - now).toFixed(2)+' seconds', "message", 30000);
// 		console.log(swapsDone+' of '+sla.length+' swaps completed successfully in '+(then - now).toFixed(2)+' seconds')
// 		setTimeout(function(){viciCommon.hideMessage();}, 10000);
// 	}else{
// 		viciCommon.hideMessage();
// 	}
//
// }

async function checkSwap(swapId, swap){
	let checked = false;
	let swapStatus = false;
	let count = 0;
	let toRet = {
		swapId: swapId,
		swapStatus: swapStatus
	}

	viciCommon.addMessage('Waiting for '+swap+' order to be filled.', "message", 30000);
	while(checked==false){
		let order = await getOrder(swapId);
		if(order){
			swapStatus = order.status;
		}
		if(swapStatus == 'FILLED' || count >= config.swapChecks){
			viciCommon.addMessage(swap+' filled.', "message", 30000);
			checked=true;
			break;
		}else{
			if(count % 10 == 0){
				viciCommon.addMessage('Waiting for '+swap+' order to be filled. '+(config.swapChecks-count)+' seconds to go.', "message", 30000);
			}
		}
		await sleep(1000);
		count++;
	}

	if(count >= config.swapChecks){
		viciCommon.addMessage(swap+' could not be filled within '+config.swapChecks+' seconds, skipping.', "message", 30000);
		let order = await getOrder(swapId);
		if(order.status!='FILLED'){//Filled in the interim
			let cres = await cancelOrder(swapId);
			console.log(cres)
			if(cres){
				swapStatus = 'CANCELED';
			}else{
				let reorder = await getOrder(swapId);
				swapStatus = reorder.status;
			}
		}else{
			swapStatus = order.status;
		}
	}

	toRet.swapStatus = swapStatus;
	return toRet;
}

async function getQuotes(){
	viciCommon.hideMessage();
	fromCoins = [];
	toCoins = [];
	let quoteTotal=0;
	let errorsOnAddChecked = false;
	let pairs = [];

	$('#from_coin_select input:checked').each(function() {
		let symbol = $(this).data('symbol').toLowerCase();
		if(coinMap.has(symbol)){
			let fromCoin = structuredClone(coinMap.get(symbol));
			let fca = String($("#from_coin_select .swap_amounts[data-symbol='"+symbol+"']").val());
			fromCoin.amount = parseFloat(fca);

			if(fromCoin.amount <= 0 || isNaN(fromCoin.amount)){
				viciCommon.addMessage('The amount of '+fromCoin.symbol+' you pay must be greater than zero', "error", 5000);
				errorsOnAddChecked = true;
				return;
			}else if(fromCoin.amount >  parseFloat(fromCoin.balance)){
				viciCommon.addMessage('You can not swap more '+fromCoin.symbol+' than your balance', "error", 5000);
				errorsOnAddChecked = true;
				return;
			}else{
				fromCoins.push(fromCoin);
				if(!fromCoin.isConvert){
					pairs.push(fromCoin.productId);
				}
			}
		}
	});

	if(errorsOnAddChecked){
		return;
	}

	if(fromCoins.length <= 0){
		viciCommon.addMessage('You must select at least one coin to swap from', "error", 30000);
		return;
	}

	$('#to_coin_select input:checked').each(function() {
		let symbol = $(this).data('symbol').toLowerCase();
		if(coinMap.has(symbol)){
			let toCoin = structuredClone(coinMap.get(symbol));
			toCoins.push(toCoin);
			if(!toCoin.isConvert){
				pairs.push(toCoin.productId);
			}
		}

	});

	if(toCoins.length <= 0){
		viciCommon.addMessage('You must select at least one coin to swap to', "error", 30000);
		return;
	}

	$('#to_search').hide();
	$('.swap_to_checkboxes').css('visibility', 'hidden');
	$('.swap_from_checkboxes').css('visibility', 'hidden');
	$("#swap_tools_from").hide();
	$("#swap_tools_to").hide();
	$('#max_from').hide();
	$('#get_quotes').hide();
	$('#one_swap').hide();

	if(pairs.length < 10){
		await getPrices(pairs);
	}else{
		await getPrices();
	}

	$('#from_coin_select .coin_selector_item').hide();
	$('#to_coin_select .coin_selector_item').hide();
	$('.coin_pc').hide();

	for(let fromCoin of fromCoins){
		if(fromCoin.isConvert){
			quoteTotal = quoteTotal + fromCoin.amount;
		}else{
			let mc = coinMap.get(fromCoin.symbol);
			quoteTotal = quoteTotal + (fromCoin.amount * mc.bestAsk.price);
		}
		$('.coin_selector_from[data-symbol="'+fromCoin.symbol+'"]').addClass('coin_selected');
		$('#from_coin_select .coin_selector_item[data-symbol="'+fromCoin.symbol+'"]').show();
		$('.coin_selector_from[data-symbol="'+fromCoin.symbol+'"] .swap_amounts').css('border', 'none');
		$('.coin_selector_from[data-symbol="'+fromCoin.symbol+'"] .swap_amounts').addClass('coin_selected');
		$('.coin_selector_from[data-symbol="'+fromCoin.symbol+'"] .swap_amounts').prop('disabled', true);
	}

	console.log("USD quote total "+quoteTotal);
	let usdAmnt = quoteTotal/toCoins.length;
	let [makerFee, takerFee] = await getFees();
	usdAmnt = usdAmnt - (usdAmnt * takerFee);

	if(usdAmnt < 0){
		$('#do_swap').hide();
		await initToCoins();
		await initFromCoins();
		viciCommon.addMessage('You do not have enough money to swap to all the coins you selected.', "error", 30000);
		return
	}

	for(let [index, toCoin] of toCoins.entries()){
		$('#to_coin_select .coin_selector_item[data-symbol="'+toCoin.symbol+'"]').show();
		$('#to_coin_select .coin_selector_to[data-symbol="'+toCoin.symbol+'"]').addClass('coin_selected');
		$('.swap_to[data-symbol="'+toCoin.symbol+'"]').css('display', 'inline-block');

		if(toCoin.isConvert){
			let convertUsdAmnt = usdAmnt + (usdAmnt * takerFee); ///No fee on converts
			toCoins[index].amount=convertUsdAmnt;
			$('.swap_to[data-symbol="'+toCoin.symbol+'"]').text(convertUsdAmnt.toFixed(8));
		}else{
			toCoin = coinMap.get(toCoin.symbol);
			toCoins[index].amount=usdAmnt;
			$('.swap_to[data-symbol="'+toCoin.symbol+'"]').text((usdAmnt/toCoin.bestAsk.price).toFixed(8));
		}
	}

	if(oneClick){
		await doSwaps();
		oneClick=false;
	}else{
		$('#do_swap').show();
		quoteTimer = setTimeout(async function(){
			await alert("Your quotes have expired. You will need to get new quotes.");
			$('#do_swap').hide();

			await initToCoins();
			await initFromCoins();

		}, 60000);
	}
}

async function initFromCoins(){
	$('#from_coin_select').html('');
	viciCommon.addMessage('Loading coins ', "message", 30000);
	let accounts = await getAccounts();
	if(accounts){
		for(let [i, account] of accounts.entries()){
			accountMap.set(account.currency.toLowerCase(), account);
			if(coinMap.has(account.currency.toLowerCase())){
				let mapCoin = coinMap.get(account.currency.toLowerCase());
				accounts[i].usdValue=mapCoin.price * parseFloat(account.available_balance.value);
			}
		}

		accounts.sort((a, b) => (parseFloat(b.usdValue) - parseFloat(a.usdValue)));

		swapFromCoins = [];
		for(let account of accounts){

			if(account.usdValue > 0.01){
				//console.log(account)
				let coin = {
					symbol : account.currency.toLowerCase(),
					displaySymbol : account.currency,
					balance : account.available_balance.value,
				}

				if(coinMap.has(coin.symbol)){
					let mapCoin = coinMap.get(coin.symbol);
					coin.productId = mapCoin.productId;
					coin.symbol = mapCoin.symbol;
					coin.displaySymbol = mapCoin.displaySymbol;
					coin.price_percentage_change_24h = mapCoin.price_percentage_change_24h;
					coin.up_dn = ((mapCoin.price_percentage_change_24h >= 0) ? 'up' : 'dn');
					coin.price = mapCoin.price;
					coin.min_size = mapCoin.min_size;
					coin.max_size = mapCoin.max_size;
					coin.increment = mapCoin.increment;
					coin.decimals = String(coin.increment).countDecimals();
					coin.usdValue = account.usdValue;
					coin.isConvert = mapCoin.isConvert;
					coinMap.set(coin.symbol, coin);
				}else{
					coinMap.set(coin.symbol, coin);
				}
				swapFromCoins.push(coin);

				let usdVal = '';

				if(coin.usdValue){
					usdVal ='($'+coin.usdValue.toFixed(2)+') ';
				}
				let balance = coin.balance;
				if(balance.length > 10)
					balance = balance.substring(0, 10);

				$('#from_coin_select').append(
				'<li class="coin_selector_item" data-symbol="'+coin.symbol+'"> \
				<span class="coin_selector coin_selector_from" data-symbol="'+coin.symbol+'">\
				<input type="checkbox" class="checkboxes swap_from_checkboxes"  data-updn="'+coin.up_dn+'" data-symbol="'+coin.symbol+'" name="'+coin.symbol+'" /> \
				<input type="number" data-symbol="'+coin.symbol+'" inputmode="decimal" class="swap_amounts" /> \
				<span class="coin_selector_inner" data-symbol="'+coin.symbol+'">\
				<div class="crop"><img src="img/coins/'+coin.symbol+'.png" alt="'+coin.displaySymbol+'" />\
				</div> <span class="coin_symbol">'+coin.displaySymbol+'</span>\
				<span data-symbol="'+coin.symbol+'" class="small_balance">'+usdVal+''+balance+'</span>\
				</span></span></li>');

			}else{
				if(account && account.usdValue){
					console.log("Skipping "+account.currency+" with a balance worth $"+ viciCommon.convertENotationToNumber(account.usdValue));
				}else if(account && account.currency){
					console.log("Skipping "+account.currency+" no USD value");
				}else{
					console.error(account);
				}
			}
		}
		if(swapFromCoins.length==0){
			viciCommon.addMessage('Could not load coins. Please refresh the page.', "error", 30000);
		}
	}
}

async function initToCoins(){
	$('#to_search').show();
	$('.swap_to_checkboxes').css('visibility', 'visible');
	$('.swap_from_checkboxes').css('visibility', 'visible');
	$("#swap_tools_from").show();
	$("#swap_tools_to").show();
	$('#max_from').show();
	$('#get_quotes').show();
	$('#one_swap').show();
	$('#select_all_from').prop('checked', false);
	$('#select_all_to').prop('checked', false);

	$('#to_coin_select').html('');
	let products = await getProducts();
	if(products && Array.isArray(products)){
		swapToCoins = [];
		for(let product of products){
			//console.log(product)
			let coin = {
				productId : product.product_id,
				symbol : product.base_display_symbol.toLowerCase(),
				displaySymbol : product.base_display_symbol,
				price_percentage_change_24h : product.price_percentage_change_24h,
				up_dn: ((product.price_percentage_change_24h > 0) ? 'up' : 'dn'),
				price : product.price,
				min_size : product.base_min_size,
				max_size : product.base_max_size,
				increment : product.base_increment,
				decimals : String(product.base_increment).countDecimals(),
				isConvert : false,
			}
			if(coinMap.has(coin.symbol)){
				let mapCoin = coinMap.get(coin.symbol);
				coin.balance = mapCoin.balance;
				coinMap.set(coin.symbol, coin);
			}else{
				coinMap.set(coin.symbol, coin);
			}
			swapToCoins.push(coin);

			if(product.approximate_quote_24h_volume > config.minToCoinVolume){
				let percentChange = '<span data-symbol="'+coin.symbol+'" class="coin_pc positive ">'+parseFloat(coin.price_percentage_change_24h).toFixed(4)+'% ▲</span>';
				if(parseFloat(coin.price_percentage_change_24h)<0){
					percentChange = '<span data-symbol="'+coin.symbol+'" class="coin_pc negative ">'+Math.abs(parseFloat(coin.price_percentage_change_24h).toFixed(4))+'% ▼</span>';
				}
				$('#to_coin_select').append('<li class="coin_selector_item" data-symbol="'+coin.symbol+'" > \
					<span class="coin_selector_to" data-symbol="'+coin.symbol+'">\
						<input type="checkbox" class="checkboxes, swap_to_checkboxes" data-updn="'+coin.up_dn+'" data-symbol="'+coin.symbol+'" name="'+coin.symbol+'" /> \
						'+percentChange+'\
						<span data-symbol="'+coin.symbol+'" class="swap_to"></span> \
						<span class="coin_selector_inner" data-symbol="'+coin.symbol+'">\
							<div class="crop"><img src="img/coins/'+coin.symbol+'.png" alt="'+coin.displaySymbol+'" /></div>\
							<span class="coin_symbol_text"> '+coin.displaySymbol+'</span>\
						</span>\
					</span>\
				</li>');
			}
		}
		//USD and EUR don't trade like normal coins they "convert" need separate logic
		for (const [natSymbol, natEnabled] of Object.entries(hasNatives)) {
			if(natEnabled){
				let coinSymbol = natSymbol;
				if(natSymbol.slice(-1)=='c'){
					coinSymbol = natSymbol.substring(0, natSymbol.length-1);
				}else{
					coinSymbol = coinSymbol+'c';
				}

				let baseSymbol = coinSymbol.substring(0,3)
				let productId = 'USDC-USD';
				if(baseSymbol=='eur'){
					productId = 'EURC-EUR';
				}
				let coin = {
					productId : productId,
					symbol : coinSymbol.toLowerCase(),
					displaySymbol : coinSymbol.toUpperCase(),
					price_percentage_change_24h : 0,
					price : 1,
					min_size : 0,
					max_size : Number.MAX_SAFE_INTEGER,
					increment : "0.01",
					decimals : 2,
					isConvert : true,
				}

				if(coinMap.has(coin.symbol)){
					let mapCoin = coinMap.get(coin.symbol);
					coin.balance = mapCoin.balance;
					coinMap.set(coin.symbol, coin);
				}else{
					coinMap.set(coin.symbol, coin);
				}

				swapToCoins.push(coin);

				let percentChange = '<span data-symbol="'+coin.symbol+'" class="coin_pc positive ">'+parseFloat(coin.price_percentage_change_24h).toFixed(4)+'% ▲</span>';
				if(parseFloat(coin.price_percentage_change_24h)<0){
					percentChange = '<span data-symbol="'+coin.symbol+'" class="coin_pc negative ">'+Math.abs(parseFloat(coin.price_percentage_change_24h).toFixed(4))+'% ▼</span>';
				}

				$('#to_coin_select').prepend('<li class="coin_selector_item" data-symbol="'+coin.symbol+'" > \
					<span class="coin_selector_to" data-symbol="'+coin.symbol+'">\
						<input type="checkbox" class="checkboxes, swap_to_checkboxes"  data-updn="up" data-symbol="'+coin.symbol+'" name="'+coin.symbol+'" /> \
						'+percentChange+'\
						<span data-symbol="'+coin.symbol+'" class="swap_to"></span> \
						<span class="coin_selector_inner" data-symbol="'+coin.symbol+'">\
							<div class="crop"><img src="img/coins/'+coin.symbol+'.png" alt="'+coin.displaySymbol+'" /></div>\
							<span class="coin_symbol_text"> '+coin.displaySymbol+'</span>\
						</span>\
					</span>\
				</li>');
			}
		}
		viciCommon.hideMessage();
		return products.length;
	}else{
		return 0;
	}
}

async function maxFrom(){
	if(swapFromCoins.length){
		$(".swap_amounts").each(function(){
			let symbol = $(this).data('symbol');
			let coin = coinMap.get(symbol);
			$(this).val(coin.balance);
		});
	}else{
		viciCommon.addMessage("Balances loading, please wait a moment", "error", 30000);
		console.log("swapFromCoins.length "+swapFromCoins.length)
	}
}

//Coinbase stuff
//=================================================================================

async function getFees(){
		let makerFee=0, takerFee=0;

		try{
			let res = await doAjax('api/fees', {}, 'GET', cbHeaders);
			if(res.status){
				makerFee=res.makerFee;
				takerFee=res.takerFee;
			}
		}catch(e)	{
			console.error(e);
		}
	return [makerFee, takerFee];
}

async function cancelOrder(order_id){
	let data = {
		"order_id": order_id,
	};
	let res;
	try{
		res = await doAjax('api/order', data, 'DELETE', cbHeaders)
		if(res.status==true){
		}else{
			console.error("Could not cancel order.");
		}
	}catch(e)	{
		console.error(e);
		console.error("Could not cancel order");
		return false;
	}
	if(res){
		return res.status;
	}else{
		return false;
	}
}

async function getConvertStatus(tradeId, fromCoin, toCoin){
	await isAuth();
	let data = {
		trade_id: tradeId,
		from_coin: fromCoin,
		to_coin: toCoin,
	};

	try{
		let res = await doAjax('api/convert', data, 'GET', cbHeaders)

		if(res.trade && res.trade.status){
			return res.trade_status;
		}else{
			if(res && res.error_response && res.error_response.message){
				console.error("Could not convert coin. "+res.error_response.message);
			}
			return false;
		}
	}catch(e)	{
		console.error(e);
		console.error("Could not convert coin");
	}
	return false;
}

async function convertCoin(tradeId, fromCoin, toCoin){
	await isAuth();
	let data = {
		trade_id: tradeId,
		from_coin: fromCoin,
		to_coin: toCoin,
	};

	try{
		let res = await doAjax('api/convert', data, 'POST', cbHeaders);
		if(res.trade_status){
			return res.trade_status;
		}else{
			console.error("Could not convert coin")
			return false;
		}
	}catch(e)	{
		console.error(e);
		console.error("Could not convert coin");
	}
	return false;
}

async function getConvertQuote(inCur, outCur, amnt){
	await isAuth();
	let data = {
		"from_account": inCur,
		"to_account": outCur,
		"amount": amnt,
	};

	try{
		let res = await doAjax('api/convertquote', data, 'GET', cbHeaders)
		if(res && res.trade_id){
			return(res.trade_id);
		}else{
			console.error("Could not get convert quote. "+res.trade.cancellation_reason.message);
			return false;
		}
	}catch(e)	{
		console.error(e);
		console.error("Could not get convert quote");
		return false;
	}
}


async function getOrder(orderId){
	await isAuth();

	let data = {
		"order_id": orderId,
	};

	try{
		let res = await doAjax('api/order', data, 'GET', cbHeaders)
		if(res && res.order){
			return res.order;
		}else{
			console.error("Could not load order "+orderId);
		}
	}catch(e)	{
		console.error(e);
		console.error("Could not load order "+orderId);
	}
}

async function getAccounts(){
	await isAuth();
	let res;
	try{
		res = await doAjax('api/accounts', {}, 'GET', cbHeaders);
	}catch(e)	{
		console.error(e);
	}
	if(res && res.status){
		return res.accounts;
	}else{
		if(res && res.error){
			console.error(res.error);
			viciCommon.addMessage(res.error, "error", 30000);
			return false;
		}else{
			console.error("Error loading accounts");
			viciCommon.addMessage("Error loading accounts", "error", 30000);
			return false;
		}
	}

}

async function getAccountBalance(symbol){
	let uuid;
	let balance = -1;
	if(accountMap.has(symbol)){
		let account = accountMap.get(symbol);
		uuid = account.uuid;
	}

	if(uuid){
		try{
			let res = await doAjax('api/account', {uuid: uuid}, 'GET', cbHeaders)
			balance = res.balance;
			return balance;
		}catch(e)	{
			console.error(e);
		}
	}else{
		console.error("Could not load balance for coin "+symbol);
	}
	return balance;
}

async function getPrices(pairs){
	await isAuth();
	try{
		let res = await doAjax('api/prices', {pairs: pairs}, 'GET', cbHeaders);
		let count = 0
		for(let price of res.pricebooks){
			let symbols = price.product_id.split('-');
			if(symbols[1]=='USD'){
				if(coinMap.has(symbols[0].toLowerCase())){
					let coin = coinMap.get(symbols[0].toLowerCase());
					coin.bestAsk = price.asks[0];
					coin.bestBid = price.bids[0];
					coinMap.set(coin.symbol, coin);
				}
			}
		}
	}catch(e)	{
		console.error(e);
	}
}

async function getProducts(){
	await isAuth();
	let retProducts = new Array();
	try{
		let res = await doAjax('api/products', {}, 'GET', cbHeaders)
		if(res && res.status){
			return res.products;
		}else{
			if(res && res.error){
				console.error(res.error);
				viciCommon.addMessage(res.error, "error", 30000);
				return res;
			}else{
				console.error("Error loading products");
				viciCommon.addMessage("Error loading products", "error", 30000);
				return false;
			}
		}

	}catch(e)	{
		console.error(e);
	}
}

async function getUser(){
	await isAuth();
	let retProducts = new Array();
	let resuser;
	try{
		let res = await doAjax('api/user', {}, 'GET', cbHeaders);
		if(res && res.status && res.user){
			resuser = res.user;
		}
	}catch(e)	{
		console.error(e);
		viciCommon.addMessage('Could not load user data', "error", 5000);
	}
	return resuser;
}

async function swap(product, buySell, amount, price){
	let toRet = {status:false};
	price = parseFloat(price);
	await isAuth();
	const client_order_id = window.crypto.randomUUID();

	let data = {
		client_order_id: client_order_id,
    	product: product,
		buy_sell: buySell,//Buy first coin on product
		amount: amount,
		price: price
	};
	try{
		let res = await doAjax('api/swap', data, 'POST', cbHeaders)
		if(res.status==true){
			return res;
		}else{
			console.error("Could not submit swap. ");
			console.error(res)
			console.log("Returning", toRet)
			return toRet;
		}
	}catch(e)	{
		console.error(e);
		console.error("Could not submit swap");
		toRet.error = "Could not submit swap";
		return toRet;
	}
}

async function isAuth(){
	const headers = {
		'Content-Type' : 'application/json',
	};
	let tokenRes = await doAjax('api/token', {}, 'GET', headers);
	if(tokenRes.status){
		$('#oAuthLogin').hide();
		$('#logout').show();
		$('#reset').show();
		$('#stats').show();
		return true;
	}else{
		$('#wrapper_inner').hide();
		showLoginModal();
		$('#logout').hide();
		$('#reset').hide();
		$('#stats').hide();
		return false;
	}
}

async function showLoginModal(){
	let config = await doAjax('api/state', {}, 'GET');
	let modalContent='<h2>Welcome to ViciSwap for Coinbase</h2>\
	To use this product you must authorize access in Coinbase<br><br>\
	<form action="'+config.coinbaseOathUri+'">\
	<input type="hidden" name="response_type" value="code">\
	<input type="hidden" name="client_id" value="'+config.coinbaseClientId+'">\
	<input type="hidden" name="redirect_uri" value="'+encodeURI(config.coinbaseCallback)+'">\
	<input type="hidden" name="state" value="'+config.state+'">\
	<input type="hidden" name="scope" value="'+encodeURI(config.coinbaseScopes)+'">\
	<input id="login" class="action_buttons" type="submit" value="Authorize" />\
	<p id="tos">By clicking authorize you agree to our <a target="_blank" href="https://www.vicinft.com/terms-of-use">Terms of Use</a></p>\
	</form>';
	await viciCommon.showModal(modalContent, true);
}

let rateLockResolve;
function rateLock(){
	return new Promise(function(resolve, reject){
		rateLockResolve = resolve;
	});
}

async function rateCheck(jqXHR, endpoint){
	if(jqXHR.getResponseHeader('x-ratelimit-remaining')){
		let requestsLeft = parseInt(jqXHR.getResponseHeader('x-ratelimit-remaining'));
		console.log(endpoint, jqXHR.getResponseHeader('x-ratelimit-limit') +" "+requestsLeft);
	}
}

async function  doAjax(url, data, type, headers) {
	let endpoint;

	let ajaxConfig={
		url: url,
		type: type,
		headers: headers,
		success: function(res, status, jqXHR) {
			//rateCheck(jqXHR, endpoint);
		}
	}

	if(data!='' && type=='GET'){
		ajaxConfig.data=data;
	}else if(data!='' && type!='GET'){
		data=JSON.stringify(data);
		ajaxConfig.data=data;
	}

	let res = await $.ajax(ajaxConfig).catch(async (jqXHR, error, errorThrown) => {
		console.log(jqXHR.getAllResponseHeaders())
		console.error("AJAX Error status "+jqXHR.status);
		if(jqXHR.status==429){
			await sleep(1000);
			console.log("Retrying request");
			return await doAjax(url, data, type, headers);
		}else if(jqXHR.status==400){
			return "error";
		}else{
			return "error";
		}
	});
	return res;
}

//Catch uncaught exceptions
window.onerror = async function myErrorHandler(errorMsg, url, lineNumber) {
	console.error('Caught uncaught exception');
	console.error(errorMsg);
	console.error("Error is on line "+lineNumber);
	return false;
}

Promise.delay = function(t, val) {
	return new Promise(resolve => {
		setTimeout(resolve.bind(null, val), t);
	});
}

Promise.raceAll = function(promises, timeoutTime, timeoutVal) {
	return Promise.all(promises.map(p => {
		return Promise.race([p, Promise.delay(timeoutTime, timeoutVal)])
	}));
}

function sleep(ms){
	return new Promise(resolve => setTimeout(resolve, ms));
}

String.prototype.countDecimals = function () {
	if(Math.floor(this.valueOf()) === this.valueOf()) return 0;
	if(this.indexOf('.')<0) return 0;
	return this.toString().split(".")[1].length || 0;
}

String.prototype.countDigits = function () {
	if(Math.floor(this.valueOf()) === this.valueOf()) return this.length;
	return this.toString().split(".")[0].length || 0;
}

function makeMultiplier(decimals){
	let toRet='';
	for(let i=0; i<decimals-1; i++){
		toRet='0'+toRet;
	}
	toRet='0.'+toRet+'1';
	return(parseFloat(toRet));
}

function copyToClipboard(string) {
	if (navigator.clipboard) {
		navigator.clipboard.writeText(string).then(function(e) {
			viciCommon.addMessage("Bundle link copied to clipboard", "message", 30000);
		}).catch(function(e) {
			viciCommon.addMessage("Could not copy bundle link to clipboard. "+e.message, "error", 30000);
		});
	} else {
		viciCommon.addMessage("Could not copy bundle link to clipboard", "error", 30000);
	}
}

async function dec(iv, k, ed){
	iv = Buffer.from(iv, "hex");
	const k1 = await crypto.subtle.importKey('raw', Buffer.from(k, 'hex'), {name: 'AES-GCM', length: 256}, true, ['encrypt', 'decrypt']);
	const d = await crypto.subtle.decrypt({name: 'AES-GCM', iv}, k1, Buffer.from(ed, 'hex'));
	return new TextDecoder().decode(d);
}

async function enc(iv, k, d){
	const ted = new TextEncoder().encode(d);
	iv = Buffer.from(iv, "hex");
	const k1 = await crypto.subtle.importKey('raw', Buffer.from(k, 'hex'), {name: 'AES-GCM', length: 256}, true, ['encrypt', 'decrypt']);
	const ed = await crypto.subtle.encrypt({name: 'AES-GCM', iv}, k1, ted);
	return(Buffer.from(ed).toString('hex'))
}